import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { AddressAudit } from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-address-audit-list',
  templateUrl: './person-profile-address-audit-list.component.html',
  styleUrls: ['./person-profile-address-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileAddressAuditListComponent implements OnInit {
  @Input() addressId: number;
  @Input() loading: boolean;
  @Input() addressAudits: AddressAudit[];

  @Output() loadAddressAudits = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadAddressAudits.emit(this.addressId);
  }

  onNextPage() {
    this.nextPage.emit(this.addressId);
  }
}
